import isEmpty from 'lodash/isEmpty'
import last from 'lodash/last'

import CookieHelper from '@/checkout-instore-legacy/utils/CookieHelper'
import { routeChangeEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'
import {
  clearStore,
  clearVendor,
  loadInStoreVendor,
} from '@/checkout-instore-legacy/vendor/actions'
import {
  getVendorStore,
  getVendor,
} from '@/checkout-instore-legacy/utils/vendorUtils'
import { orderFormIdSelector } from '@/checkout-instore-legacy/order/selectors'

export function hidePastOrderTopbar(location) {
  const { query } = location
  return isEmpty(query)
}

export function vendorLoggedIn(nextState, replace) {
  const vtexIdToken = CookieHelper.getVtexIdToken()

  if (!vtexIdToken) {
    getReduxStore().dispatch(clearStore())
    getReduxStore().dispatch(clearVendor())
    replace('/vendor/login')
    return false
  }

  return true
}

function vendorAuthorizedWithData(nextState, replace) {
  let store = getVendorStore()
  let vendor = getVendor()

  if (!store || !vendor) {
    getReduxStore().dispatch(loadInStoreVendor())
    store = getVendorStore()
    vendor = getVendor()
  }

  if (!store && !vendor) {
    replace('/vendor/login')
    return false
  }

  return true
}

function hasExternalCartToGo() {
  const { externalCart } = getReduxStore().getState().cart
  return externalCart && (externalCart.change || externalCart.copy)
}

function hasOrderForm(nextState, replace) {
  const orderFormId = orderFormIdSelector(getReduxStore().getState())
  const hasExternalCart = hasExternalCartToGo()

  if (!orderFormId && !hasExternalCart) {
    replace('/')
    return false
  }

  return true
}

function composeValidations(validations) {
  return (nextState, replace) => {
    const currentRoute = last(nextState.routes)

    let path = currentRoute?.path ? currentRoute?.path : '/'
    const context = currentRoute?.context

    validations.every((validation) =>
      validation(nextState, (newPath) => {
        if (!newPath) {
          return
        }
        if (newPath !== '/' && newPath[0] === '/') {
          path = newPath.substring(1, newPath.length)
        } else {
          path = newPath
        }

        replace(newPath)
      })
    )

    routeChangeEvent(path, context)
  }
}

export function noValidationRequired(nextState, replace, callback = () => {}) {
  const validationFn = composeValidations([])
  validationFn(nextState, replace)
  return callback()
}

export function withVendorLoggedIn(nextState, replace, callback = () => {}) {
  const validationFn = composeValidations([vendorLoggedIn])
  validationFn(nextState, replace)
  return callback()
}

export function withVendorAuthorized(nextState, replace, callback = () => {}) {
  const validationFn = composeValidations([
    vendorLoggedIn,
    vendorAuthorizedWithData,
  ])
  validationFn(nextState, replace)
  return callback()
}

export function withOrderFormContext(nextState, replace, callback = () => {}) {
  const validationFn = composeValidations([
    vendorLoggedIn,
    vendorAuthorizedWithData,
    hasOrderForm,
  ])
  validationFn(nextState, replace)
  return callback()
}
